<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
  >
  <div class="to-left d-flex align-items-center full-width">
    <nz-select
      style="max-width: 200px;"
      class="full-width"
      [disabled]="!selectedDate"
      [(ngModel)]="selectedOperator"
      (ngModelChange)="onRefreshList()"
      nzPlaceHolder="Vergleich"
      aria-label="MHD-Vergleich"
      >
      @for (operator of operators; track operator) {
        <nz-option [nzValue]="operator.value" [nzLabel]="operator.label"></nz-option>
      }
    </nz-select>
    <nz-date-picker
      style="margin-left: 10px; max-width: 200px;"
      [nzFormat]="dateFormat"
      [(ngModel)]="selectedDate"
      (ngModelChange)="onRefreshList()"
      [nzAllowClear]="false"
      nzPlaceHolder="Datum"
      aria-label="MHD-Datum"
    ></nz-date-picker>
    <label
      style="margin-left: 10px;"
      nz-checkbox
      [(ngModel)]="showEmptyMhd"
      (ngModelChange)="showEmptyMhdChange()"
    >Leere MHD anzeigen</label>
  </div>
</app-table-header>
<nz-table appColumnLayout
  #tableRef
  nzShowSizeChanger
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="mhd-list-table"
  >
  <thead>
    <tr>
      <th nzColumnKey="storageLocationNumber" [nzSortFn]="true">Lagerplatz</th>
      <th nzColumnKey="fullName" [nzSortFn]="true">Name</th>
      <th nzColumnKey="mhd" [nzSortFn]="true" nzSortOrder="descend">Haltbar bis</th>
      <th nzColumnKey="isActive" [nzSortFn]="true" nzSortOrder="isActive">Aktiv</th>
      <th nzColumnKey="actions"></th>
    </tr>
  </thead>
  <tbody>
    @for (article of data.results; track article) {
      <tr>
        <td>{{ article.storageLocationNumber }}</td>
        <td>{{ article.fullName }}</td>
        <td>{{ article.mhd | dateFormat }}</td>
        <td nzAlign="center"><app-boolean-icon [state]="article.isActive"></app-boolean-icon></td>
        <td nzRight>
          <div class="actions">
            <app-icon-button
              icon="edit"
              [ariaLabel]="'MHD ändern: ' + article.fullName"
              (pressed)="changeMhdModalComponent.showModal({ articleVariant: article })"
            ></app-icon-button>
            <app-add-edit-article-modal #modal (mhdChanged)="onRefreshList()">
              <span trigger>
                <app-icon-button
                  icon="eye"
                  [ariaLabel]="'Artikel bearbeiten: ' + article.fullName"
                  (pressed)="modal.showModal($any({ id: article.articleId, name: article.articleName }))"
                ></app-icon-button>
              </span>
            </app-add-edit-article-modal>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
<app-change-mhd-modal #changeMhdModalComponent (mhdChanged)="onRefreshList()" />
